<template>
  <div v-if="!online" class="api-banner" role="alert">
    <div class="api-banner-inner">
      <i class="pi pi-wifi" aria-hidden="true" />
      <div>
        <strong>API offline</strong>
        <span> — reconnecting… Run <code>npm run dev</code> and leave it open.</span>
      </div>
      <Button
        label="Retry now"
        icon="pi pi-refresh"
        class="p-button-sm p-button-outlined"
        :loading="checking"
        @click="check(true)"
      />
    </div>
  </div>
</template>

<script>
const API_HTTP = process.env.VUE_APP_API_HTTP
  || (process.env.NODE_ENV === 'development' && typeof location !== 'undefined'
    ? `http://${location.hostname || 'localhost'}:4000`
    : '')

export default {
  data() {
    return {
      online: true,
      checking: false,
      timer: null,
    }
  },
  mounted() {
    this.check(false)
    this.timer = setInterval(() => this.check(false), 4000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    async check(manual) {
      if (manual) this.checking = true
      const wasOffline = !this.online
      try {
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
        const t = setTimeout(() => controller && controller.abort(), 2500)
        const res = await fetch(`${API_HTTP}/graphql`, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ query: '{ __typename }' }),
          signal: controller ? controller.signal : undefined,
        })
        clearTimeout(t)
        this.online = res.ok
      } catch (e) {
        this.online = false
      } finally {
        this.checking = false
      }
      if (wasOffline && this.online && this.$apollo) {
        try {
          this.$apollo.getClient().reFetchObservableQueries()
        } catch (e) { /* ignore */ }
      }
    },
  },
}
</script>

<style scoped>
.api-banner {
  position: sticky;
  top: 0;
  z-index: 40;
  background: #450a0a;
  color: #fecaca;
  border-bottom: 1px solid #7f1d1d;
}

.api-banner-inner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  font-size: 0.875rem;
}

.api-banner-inner code {
  font-size: 0.8em;
  background: rgba(0, 0, 0, 0.25);
  padding: 0.1rem 0.35rem;
  border-radius: 4px;
}

.api-banner-inner .p-button {
  margin-left: auto;
  color: #fecaca !important;
  border-color: #fca5a5 !important;
}
</style>
